import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeWaitingForAnswersRoute extends Route {
  @service store;

  async model() {
    const initiative = this.modelFor('backlog.initiatives.initiative');
    const wfas = await initiative.hasMany('wfas').load();
    await this.store.query('wfa', {
      filter: {
        archived: true,
        initiative: initiative.id,
      },
    });
    return {
      initiative,
      wfas,
    };
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativeWaitingForAnswersRoute,
);
